import moment from 'moment';

export const set_patch_time = () => {
	localStorage.setItem('patchTime', JSON.stringify(moment().add(5, 'm')));
};

export const remove_patch_time = () => {
	localStorage.removeItem('patchTime');
};
